module.exports = __webpack_public_path__ + "static/media/prod16.c997c396.jpg";